export default {
  guideContainer: {
    maxWidth: 980,
    margin: '0 auto',
    padding: 30,
    background: '#fafafa',
    borderRadius: 14,
    boxShadow: '0 4px 15px rgba(0,0,0,0.06)',
    fontFamily: "'Inter', sans-serif",
    color: '#2d3436',
  },

  guideTitle: {
    textAlign: 'center',
    fontSize: 28,
    marginBottom: 10,
    color: '#1e3799',
  },

  guideSubtitle: {
    textAlign: 'center',
    fontSize: 15,
    color: '#636e72',
    marginBottom: 30,
  },

  tagsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: 20,
  },

  tagCard: {
    background: 'white',
    borderRadius: 10,
    padding: 18,
    border: '1px solid #dfe6e9',
    boxShadow: '0 3px 8px rgba(0,0,0,0.04)',
  },

  tagCardTitle: {
    marginBottom: 10,
    color: '#0984e3',
  },

  tagList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },

  tagPill: {
    background: '#dfe6e9',
    padding: '5px 10px',
    borderRadius: 5,
    fontFamily: 'monospace',
    fontSize: 13,
  },

  section: {
    marginTop: 40,
  },

  sectionTitle: {
    color: '#1e90ff',
    marginBottom: 10,
  },

  codeBlock: {
    background: '#2d3436',
    color: '#dfe6e9',
    padding: 14,
    borderRadius: 6,
    whiteSpace: 'pre-wrap',
    fontSize: 13,
    marginTop: 10,
  },

  noteBox: {
    background: '#fff6d6',
    borderLeft: '4px solid #f1c40f',
    padding: 20,
    marginTop: 40,
    borderRadius: 8,
  },

  noteTitle: {
    marginBottom: 10,
    color: '#b8860b',
  },

  noteList: {
    margin: 0,
    paddingLeft: 20,
  },
};
